<template>
  <span :class="cusprop.class" class="greenBtn" @click="goFun"
    >{{ text || "详情" }}
  </span>
</template>

<script>
import editDevice from "@/views/cards/edit.vue";
import editMaintenance from "@/views/equipmentDic/maintenance/edit.vue";
import { deleteDevice } from "@/api/device/index.js";
import { deleteFence } from "@/api/fence/index.js";
import { deleteWxqc } from "@/api/equipmentDic/index.js";
import { lonlats2cartesians } from "@/utils/cesiumBD/analysis/utils/geojson";
import { deleteMark } from "@/api/vectorPlot/index.js";
import { deleteShipType } from "@/api/shipType/index.js";
import { getCommonAjax } from "@/api/common";
import editShipType from "@/views/shipType/add.vue";
import flySet from "@/components/FlightRoam/set.vue";
//src\components\carTree\sendPageIMG.vue
import sendPageMSG from "@/components/carTree/sendPageIMG.vue";
import sendPageAudio from "@/components/carTree/sendPageAudio.vue";
import PathAnimation from "@/utils/cesiumBD/animation/PathAnimation";
import DeviceMsg from "../../DeviceMsg/super.vue";
import PopLayer from "@/utils/cesiumBD/animation/PopLayer";
import { getModelUrl } from "@/components/GIS-map/getModel";
export default {
  props: {
    row: {},
    cusprop: {
      type: Object,
      default: {
        text: "",
        prop: "",
        method: "",
      },
    },
  },
  computed: {
    text() {
      if (this.cusprop.prop) {
        return this.getValue(this.row, this.cusprop.prop);
      }
      return this.cusprop.text || "-";
    },
  },
  methods: {
    goFun() {
      var method = this[this.cusprop.method];
      method(); //执行
    },
    /**
     * 使用Cesium插值属性实现折线平滑
     * @param {Array} points - Cesium.Cartesian3点数组，表示原始折线
     * @param {Object} [options] - 插值选项
     * @param {Number} [options.degree=3] - 插值多项式次数
     * @param {Cesium.InterpolationAlgorithm} [options.algorithm=Cesium.HermitePolynomialApproximation] - 插值算法
     * @param {Number} [options.samplesPerSegment=10] - 每段生成的样本点数
     * @returns {Array} 平滑后的曲线点数组
     */
    createCurvedLine(points, options = {}) {
      const {
        degree = 3,
        algorithm = Cesium.HermitePolynomialApproximation,
        samplesPerSegment = 10,
      } = options;

      if (!points || points.length < 2) return points;

      // 创建位置属性并设置插值选项
      const positionProperty = new Cesium.SampledPositionProperty();
      positionProperty.setInterpolationOptions({
        interpolationDegree: degree,
        interpolationAlgorithm: algorithm,
      });

      // 添加采样点（使用正确的时间API）
      const startTime = Cesium.JulianDate.now();

      points.forEach((point, index) => {
        const time = Cesium.JulianDate.addSeconds(
          startTime,
          index,
          new Cesium.JulianDate()
        );
        positionProperty.addSample(time, point);
      });

      // 生成平滑曲线
      const result = [];
      const totalDuration = points.length - 1;

      for (let i = 0; i < totalDuration; i++) {
        for (let j = 0; j <= samplesPerSegment; j++) {
          const time = i + j / samplesPerSegment;
          const sampleTime = Cesium.JulianDate.addSeconds(
            startTime,
            time,
            new Cesium.JulianDate()
          );
          const position = positionProperty.getValue(sampleTime);

          if (position) {
            result.push(position);
          }
        }
      }

      // 确保包含原始端点
      if (result.length > 0) {
        if (!Cesium.Cartesian3.equalsEpsilon(result[0], points[0], 1e-10)) {
          result.unshift(points[0]);
        }

        const lastPoint = points[points.length - 1];
        if (
          !Cesium.Cartesian3.equalsEpsilon(result[result.length - 1], lastPoint, 1e-10)
        ) {
          result.push(lastPoint);
        }
      }

      return result;
    },
    // 轨迹回放
    trackReplay() {
      console.log("**轨迹回放点位**", this.row.trajectoryPoints);

      let lineArr = this.removeDuplicateData(this.row.trajectoryPoints);
      //DBentityCollection.removeById("轨迹回放");

      let d = this.$dialog.getDialog("飞行回放");
      d.min();

      let obj = this.getData(lineArr, this.row.name, this.row.id);
      if (!obj || !obj.entity) {
        return;
      }

      var animation = new PathAnimation({
        entity: obj.entity,
        positions: obj.positions,
        speed: 200,
        multiple: 1,
        originPath: lineArr,
        //sumTime:10
      });

      animation.start();

      var pop = new PopLayer({
        entity: obj.entity,
        dialog: this.$dialog,
        componet: DeviceMsg,
        subData: this.row.cardNum,
        title: "设备信息",
        animation: animation,
      });
      pop.open();

      viewer.flyTo(obj.entity, {
        duration: 3,
        //offset: new Cesium.HeadingPitchRange(0, -Math.PI / 2, 15000),//（heading,pich,range）
      });

      window.__popCollection__.push(pop);
      window.__entityCollection__.push(obj.entity);
    },

    getData(arr, name, id) {
      let url = getModelUrl(id);
      var positions = [];
      var lineCoods = [];
      let baseH = 0; //modelBaseH; //基础高度8千米
      for (let i = 0; i < arr.length; i++) {
        var item = arr[i];
        var pos = Cesium.Cartesian3.fromDegrees(
          item.longitude,
          item.latitude,
          baseH + item.altitude
        );
        positions.push(pos);
        lineCoods.push([item.longitude, item.latitude, baseH + item.altitude]);
      }
      if (lineCoods.length > 2) {
        positions = this.densifyPositions(positions, 88); //加密
        positions = this.createCurvedLine(positions, {
          degree: 2,
          algorithm: Cesium.HermitePolynomialApproximation, //Cesium.LagrangePolynomialApproximation,Cesium.HermitePolynomialApproximation,Cesium.LinearApproximation
          samplesPerSegment: 50,
        });
      }

      var entity = DBentityCollection.getById(id);
      //var text = `卡号(${this.searchForm.sendCardNumber})`;
      if (!entity) {
        entity = this.createFlydEntity(positions[0], id, name, positions, url);
        DBentityCollection.add(entity);
      }

      entity.fltPath = true;

      return { entity, positions };
    },
    densifyPositions(positions, interval = 10) {
      const result = [];
      for (let i = 0; i < positions.length - 1; i++) {
        const start = positions[i];
        const end = positions[i + 1];
        result.push(start);

        const distance = Cesium.Cartesian3.distance(start, end);
        if (distance > interval) {
          const segments = Math.floor(distance / interval);
          for (let j = 1; j < segments; j++) {
            const t = (j * interval) / distance;
            const interpolated = new Cesium.Cartesian3();
            Cesium.Cartesian3.lerp(start, end, t, interpolated);
            result.push(interpolated);
          }
        }
      }
      result.push(positions[positions.length - 1]);
      return result;
    },
    createFlydEntity(center, id, text, positions, url) {
      const entity = new Cesium.Entity({
        id: id,
        position: center,
        label: {
          text: text || "设备",
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
          font: "16px sans-serif",
          pixelOffset: new Cesium.Cartesian2(0, -20), //6,229,72
          fillColor: new Cesium.Color(6 / 255, 229 / 255, 72 / 255),
          //pixelOffsetScaleByDistance: new Cesium.NearFarScalar(1.0e3, -20, 1.5e6, -80),
        },
        model: {
          show: true,
          uri: url || "data/mx/feiji.glb", //模型的地址
          scale: modelScale, //模型缩放比例
          minimumPixelSize: modelMinimumPixelSize, //
          maximumScale: 20000, // 模型的最大比例尺大小。 minimumPixelSize的上限
          incrementallyLoadTextures: true, // 加载模型后纹理是否可以继续流入
          runAnimations: true, // 是否应启动模型中指定的glTF动画
          clampAnimations: true, // 指定glTF动画是否应在没有关键帧的持续时间内保持最后一个姿势
          shadows: Cesium.ShadowMode.ENABLED,
          heightReference: Cesium.HeightReference.NONE, //设置模型贴地,
        },
        polyline: {
          positions: positions,
          width: 10,
          //granularity: 10, // 减少granularity可以减少顶点数量
          material: new Cesium.PolylineArrowMaterialProperty(
            Cesium.Color.fromRandom({
              alpha: 1.0,
            })
          ),
        },
      });
      return entity;
    },
    removeDuplicateData(positions) {
      if (positions.length < 2) {
        return positions;
      }
      let res = [];
      let j = 0;
      res.push(positions[0]);
      for (let i = 1; i < positions.length; i++) {
        if (
          res[j].longitude == positions[i].longitude &&
          res[j].latitude == positions[i].latitude &&
          res[j].altitude == positions[i].altitude
        ) {
          continue;
        }
        j++;
        res.push(positions[i]);
      }
      return res;
    },
    removeDuplicate(positions) {
      if (positions.length < 2) {
        return positions;
      }
      let res = [];
      let j = 0;
      res.push(positions[0]);
      for (let i = 1; i < positions.length; i++) {
        if (
          res[j].x == positions[i].x &&
          res[j].y == positions[i].y &&
          res[j].z == positions[i].z
        ) {
          continue;
        }
        j++;
        res.push(positions[i]);
      }
      return res;
    },
    openVoice() {
      this.$dialog.open({
        title: "发送语音",
        theme: "feature-dialog",
        shade: true,
        area: {
          height: "600px",
          width: "680px",
        },
        location: {
          top: "100px",
        },
        content: {
          type: "vue",
          subCom: sendPageAudio,
          subData: {
            model: "model_" + this.row.sendBdNum,
          },
        },
      });
    },
    //查看图片对话框
    openPic() {
      this.$dialog.open({
        title: "发送图片",
        theme: "feature-dialog",
        shade: true,
        area: {
          height: "600px",
          width: "680px",
        },
        location: {
          top: "100px",
        },
        content: {
          type: "vue",
          subCom: sendPageMSG,
          subData: {
            model: "model_" + this.row.sendBdNum,
          },
        },
      });
    },
    //删除
    deleteflyRow() {
      this.$bus.$emit("deleteflyRow", this.row.id);
    },
    //飞行设置
    flySet() {
      var ins = this.$dialog.getDialog("飞行参数设置");
      if (ins) {
        return;
      }
      this.$dialog.open({
        id: "飞行参数设置",
        title: "飞行参数设置",
        theme: "feature-dialog",
        shade: false,
        area: {
          height: "800px",
          width: "300px",
        },
        location: {
          top: "7%", //"80px",
          left: "340px",
        },
        content: {
          type: "vue",
          subCom: flySet,
          subData: this.row,
        },
      });
    },
    editDevice() {
      var ins = this.$dialog.getDialog("编辑设备");
      if (ins) {
        return;
      }
      this.$dialog.open({
        id: "编辑设备",
        title: "编辑设备",
        theme: "feature-dialog",
        shade: true,
        area: {
          height: "240px",
          width: "400px",
        },
        // location: {
        //   top: null,
        //   left: null,
        //   bottom: "300px",
        //   right: "20px",
        // },
        content: {
          type: "vue",
          subCom: editDevice,
          subData: this.row,
        },
      });
    },
    deleteshipType() {
      this.$confirm("是否删除该条数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteShipType(this.row.id).then(() => {
            this.$message({
              showClose: true,
              message: "删除成功！",
              type: "success",
              duration: 3 * 1000,
            });
            this.$bus.$emit("shipType-list");
          });
        })
        .catch(() => {
          this.$message({
            showClose: true,
            type: "info",
            message: "本次操作已取消！",
            duration: 3 * 1000,
          });
        });
    },
    editshipType() {
      var ins = this.$dialog.getDialog("编辑舰船型号");
      if (ins) {
        return;
      }
      this.$dialog.open({
        id: "编辑舰船型号",
        title: "编辑舰船型号",
        theme: "feature-dialog",
        shade: true,
        area: {
          height: "240px",
          width: "400px",
        },
        content: {
          type: "vue",
          subCom: editShipType,
          subData: JSON.parse(JSON.stringify(this.row)),
        },
      });
    },
    exportFilterXML() {
      getCommonAjax("/wx/downloadxml?type=" + this.row.type, {}, "arraybuffer")
        .then((res) => {
          this.downloadJsonFile(res, "装备字典数据_" + new Date().getTime() + ".xml");
        })
        .catch((err) => {
          console.error(err);
        });
    },
    downloadJsonFile(data, fileName) {
      var blob = new Blob([data], { type: "application/octet-stream" });
      var url = URL.createObjectURL(blob);
      var link = document.createElement("a");
      link.download = fileName;
      link.href = url;
      link.click();
      URL.revokeObjectURL(url);
    },
    deleteDevice() {
      this.$confirm("是否删除该条数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteDevice({ id: this.row.id }).then(() => {
            this.$message({
              showClose: true,
              message: "删除成功！",
              type: "success",
              duration: 3 * 1000,
            });
            this.$bus.$emit("device-list");
          });
        })
        .catch(() => {
          this.$message({
            showClose: true,
            type: "info",
            message: "本次操作已取消！",
            duration: 3 * 1000,
          });
        });
    },

    deleteFence() {
      this.$confirm("是否删除该条数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteFence(this.row.id).then(() => {
            this.$message({
              showClose: true,
              message: "删除成功！",
              type: "success",
              duration: 3 * 1000,
            });
            this.$bus.$emit("fence-list");
            var uuid = this.row.id + "_wl_";
            var entity = DBentityCollection.getById(uuid);
            if (entity) {
              DBentityCollection.remove(entity);
              DBentityCollection.removeById(uuid);
              viewer.entities.remove(entity);
            }
          });
        })
        .catch(() => {
          this.$message({
            showClose: true,
            type: "info",
            message: "本次操作已取消！",
            duration: 3 * 1000,
          });
        });
    },
    flyToVectorPlot() {
      DBmap.plotUti.zoomTo(this.row);
    },
    deleteVectorPlot() {
      this.$confirm("是否删除该条数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteMark(this.row.id).then(() => {
            this.$message({
              showClose: true,
              message: "删除成功！",
              type: "success",
              duration: 3 * 1000,
            });
            this.$bus.$emit("vectorPlot-list");
            DBmap.plotUti.deleteVectorPlot(this.row.markId);
            var ins = this.$dialog.getDialog(this.row.markId);
            if (ins) {
              ins.close();
            }
          });
        })
        .catch(() => {
          this.$message({
            showClose: true,
            type: "info",
            message: "本次操作已取消！",
            duration: 3 * 1000,
          });
        });
    },
    editMaintenance() {
      this.$dialog.open({
        title: "编辑维修器材",
        theme: "feature-dialog",
        shade: true,
        area: {
          height: "350px",
          width: "680px",
        },
        content: {
          type: "vue",
          subCom: editMaintenance,
          subData: JSON.parse(JSON.stringify(this.row)),
        },
      });
    },
    deleteMaintenance() {
      this.$confirm("是否删除该条数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteWxqc(this.row.id).then(() => {
            this.$message({
              showClose: true,
              message: "删除成功！",
              type: "success",
              duration: 3 * 1000,
            });
            this.$bus.$emit("maintenance-list");
          });
        })
        .catch(() => {
          this.$message({
            showClose: true,
            type: "info",
            message: "本次操作已取消！",
            duration: 3 * 1000,
          });
        });
    },
    flyToLine() {
      var obj = JSON.parse(this.row.line);
      var uuid = this.row.id + "_xl_";
      var entity = viewer.entities.getById(uuid);
      if (!entity) {
        entity = this.createLineEntity(obj, uuid);
      }
      entity.show = !entity.show;
      if (entity.show) {
        viewer.flyTo(entity);
      }
    },
    createLineEntity(positions, id) {
      var line = viewer.entities.add({
        show: false,
        id: id,
        polyline: {
          positions: positions,
          show: true,
          material: Cesium.Color.RED,
          width: 3,
          clampToGround: true,
          disableDepthTestDistance: Number.MAX_VALUE,
        },
      });
      return line;
    },
    flyToFence() {
      var obj = JSON.parse(`[${this.row.fw}]`);
      console.log(obj);
      var len = obj.length;
      var uuid = this.row.id + "_wl_";
      var entity = DBentityCollection.getById(uuid);
      if (!entity) {
        //type1
        var m =
          this.row.type == 1
            ? new Cesium.StandardWallMaterialProperty({
                color: new Cesium.Color(1.0, 0.0, 0.0, 1.0),
                duration: 2000,
                count: 100,
              })
            : new Cesium.DynamicWallMaterialProperty({
                color: new Cesium.Color(1.0, 0.0, 0.0, 0.3),
                duration: 3000,
              });
        entity = this.createWallEntity(obj, uuid, len, m);
        DBentityCollection.add(entity);
      }
      entity.show = !entity.show;
      if (entity.show) {
        viewer.flyTo(entity);
      }
    },
    createWallEntity(positions, id, len, material) {
      var wall = viewer.entities.add({
        show: false,
        id: id,
        wall: {
          positions: lonlats2cartesians(positions),
          // 设置高度
          maximumHeights: new Array(len).fill(5000),
          minimumHeights: new Array(len).fill(0),
          material: material,
        },
      });
      return wall;
    },
    goMultipleIPLoginDetail() {
      this.$store.commit("business/SET_MultipleIPMap", this.row);
      this.$router.push({
        path: "/detail/multipleIPLoginDetail",
        query: { id: this.row._id },
      });
    },
    goAPICallDetail() {
      this.$router.push({
        path: "/detail/apiCallDetail",
        query: { id: this.row.evtid.id },
      });
    },
    goDatabaseAccessDetail() {
      this.$router.push({
        path: "/detail/databaseAccessDetail",
        query: { id: this.row.evtid.id },
      });
    },
    goCloudPlatformDetail() {
      this.$router.push({
        path: "/detail/cloudPlatformDetail",
        query: { id: this.row.evtid.id },
      });
    },
    //下载传输文件
    downfileTransfer() {
      downloadFile()
        .then((res) => {
          const blob = new Blob([res], { type: "application/octet-stream" });
          downloadBlob(blob, "测试.text");
        })
        .catch((e) => {
          console.error(e);
        });
    },
    getValue(row, prop) {
      if (!prop) return "-";
      if (prop.indexOf(".") > -1) {
        return this.$jsonPath(row, prop) ? this.$jsonPath(row, prop) : "-";
      }
      if (row[prop] === "" || row[prop] === null || row[prop] === undefined) {
        return "-";
      }
      return row[prop];
    },
  },
};
</script>

<style lang="scss" scoped>
.greenBtn {
  color: #1da373;
  cursor: pointer;
}

.edit {
  color: #72ddff;
  cursor: pointer;
}

.playback {
  color: #2289f6;
  cursor: pointer;
}

.delete {
  color: #ff9e9e;
  cursor: pointer;
}
</style>
